import { createApiSlice } from "@common";
import {
  CURD_RELATIONSHIP_STATUS
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addRelationshipStatus",
    method: "post",
    url: CURD_RELATIONSHIP_STATUS,
    stateKey: "message",
  },
  {
    name: "getRelationshipStatus",
    method: "get",
    url: CURD_RELATIONSHIP_STATUS,
    stateKey: "data",
  },
  {
    name: "updateRelationshipStatus",
    method: "put",
    url: CURD_RELATIONSHIP_STATUS,
    stateKey: "message",
  },
  {
    name: "deleteRelationshipStatus",
    method: "delete",
    url: CURD_RELATIONSHIP_STATUS,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "relationshipStatus",
  apiConfig,
  customReducers,
);
const relationshipStatusSlice = slice;
// Export the slice's reducer
export default relationshipStatusSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addRelationshipStatus,
  getRelationshipStatus,
  updateRelationshipStatus,
  deleteRelationshipStatus
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
